import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { CoveragePeriodStatus } from './common';

import styles from './CoverageHeaderLeft.module.css';

const CoverageSubtitleHeading = ({ children }) => (
  <h5 className={styles.coveragePeriodSubtitle}>
    {children}
  </h5>
);

const CoverageHeaderLeft = ({
  isCoveragePeriodCompleted = false,
  noPendingAction = false,
  planEndDate = '',
  planName = '',
  planStartDate = '',
  policyTerm = 1,
}) => {
  const { t } = useTranslation('petDemos');

  return (
    <div className={styles.policyActionCardHeaderLeft}>
      <div className={styles.policyActionCardTitleRow}>
        <h4 className={styles.policyCoverageTitle}>
          {t('policyInformation.coverageTitle', { policyTerm })}
        </h4>

        <div className={styles.coveragePeriodStatusContainer}>
          <CoveragePeriodStatus
            isCoveragePeriodCompleted={isCoveragePeriodCompleted}
            noPendingAction={noPendingAction}
          />
        </div>
      </div>

      <div className={styles.coveragePeriodSubtitleRow}>
        <div className={styles.coveragePeriodSubtitleItem}>
          <Trans
            components={{
              header: <CoverageSubtitleHeading />,
            }}
            i18nKey="policyInformation.planDatesLabel"
            ns="petDemos"
            values={{
              end: planEndDate,
              interpolation: { escapeValue: false },
              start: planStartDate,
            }}
          />
        </div>

        <div className={styles.coveragePeriodSubtitleItem}>
          <Trans
            components={{
              header: <CoverageSubtitleHeading />,
            }}
            i18nKey="policyInformation.planNameLabel"
            ns="petDemos"
          />

          <span>{planName}</span>
        </div>
      </div>
    </div>
  );
};

export { CoverageHeaderLeft };
